"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPicker = void 0;
var react_1 = __importStar(require("react"));
var react_color_1 = require("react-color");
var storybook_1 = require("@eyecons/storybook");
function ColorPicker(_a) {
    var className = _a.className, _b = _a.value, value = _b === void 0 ? '#EC2F2F' : _b, onChange = _a.onChange;
    var _c = react_1.useState(false), open = _c[0], setOpen = _c[1];
    function swatchClick() {
        setOpen(!open);
    }
    function handleClose() {
        setOpen(false);
    }
    function handleChangeComplete(color) {
        onChange(color.hex);
    }
    return react_1.default.createElement("div", { className: storybook_1.Helpers.classNames('storybook-forms-colorpicker', className) },
        react_1.default.createElement("div", { onClick: swatchClick, className: 'storybook-forms-colorpicker-swatch' },
            react_1.default.createElement("div", { className: 'storybook-forms-colorpicker-swatch-hex' }, value),
            react_1.default.createElement("div", { className: 'storybook-forms-colorpicker-swatch-color', style: { backgroundColor: value } })),
        open &&
            react_1.default.createElement("div", { className: 'storybook-forms-colorpicker-popover' },
                react_1.default.createElement("div", { className: 'storybook-forms-colorpicker-cover', onClick: handleClose }),
                react_1.default.createElement(react_color_1.SketchPicker, { color: { hex: value }, onChangeComplete: handleChangeComplete })));
}
exports.ColorPicker = ColorPicker;
